import { Toast } from "src/data/types";

export const TOASTER_TIMEOUT = 10000;
export const CREATE_INSPECTION_SUCCESS_TOAST = {
  message: `Inspection has been successfully published.`,
  timeout: TOASTER_TIMEOUT,
  type: "success",
};
